export function About() {
  return (
    <div className="px-4 sm:px-6 lg:px-8 py-6 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold text-[#2D3142] dark:text-white mb-6">About Airtime</h1>
      <div className="mb-8 flex justify-center">
        <img src="/airtime.svg" alt="Airtime" className="h-28 w-64 object-contain" />
      </div>

      <div className="space-y-6 text-sm leading-relaxed text-[#4F5D75] dark:text-[#BFC0C0]">
        <p>
          <span className="font-semibold text-[#2D3142] dark:text-white">Airtime</span> is a
          free-flight logbook for paraglider and hang-glider pilots. Upload your IGC track
          files, visualise your flights on a map, and keep a detailed record of every session
          in the air.
        </p>

        <div className="bg-white dark:bg-[#2D3142] rounded-lg shadow px-6 py-5 space-y-4">
          <h2 className="text-xs font-semibold uppercase tracking-wider text-[#EF8354]">What you can do</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>
              <span className="font-medium text-[#2D3142] dark:text-white">Log your flights</span> — upload
              IGC files and Airtime will automatically parse the track, compute statistics
              (distance, duration, max altitude, climb rates), and score the flight.
            </li>
            <li>
              <span className="font-medium text-[#2D3142] dark:text-white">Browse takeoff sites</span> — discover
              launch sites used by the community and link your flights to them.
            </li>
            <li>
              <span className="font-medium text-[#2D3142] dark:text-white">Manage your gear</span> — keep track
              of the gliders you fly and associate them with individual flights.
            </li>
            <li>
              <span className="font-medium text-[#2D3142] dark:text-white">Follow other pilots</span> — stay up
              to date with the flights of pilots you follow through a personalised activity
              feed.
            </li>
            <li>
              <span className="font-medium text-[#2D3142] dark:text-white">Comment and share photos</span> — add
              comments and photos to any flight to share the story behind the track.
            </li>
            <li>
              <span className="font-medium text-[#2D3142] dark:text-white">Track your progress</span> — view
              per-year statistics and flight-per-month charts on your pilot profile.
            </li>
          </ul>
        </div>

        <div className="bg-white dark:bg-[#2D3142] rounded-lg shadow px-6 py-5 space-y-4">
          <h2 className="text-xs font-semibold uppercase tracking-wider text-[#EF8354]">Open to everyone</h2>
          <p>
            All flights and pilot profiles are publicly visible, so you can browse without an
            account. To upload flights, manage gliders, follow pilots, and interact with the
            community you just need to sign in.
          </p>
        </div>

        <div className="bg-white dark:bg-[#2D3142] rounded-lg shadow px-6 py-5 space-y-4">
          <h2 className="text-xs font-semibold uppercase tracking-wider text-[#EF8354]">Support</h2>
          <p>
            Airtime is a community project, built and maintained by pilots for pilots. If you have
            questions, feedback, or need help, feel free to reach out at{' '}
            <a href="mailto:hello@air-time.net" className="text-[#EF8354] hover:underline">
              hello@air-time.net
            </a>.
          </p>
        </div>

        <p className="text-xs text-[#4F5D75]/60 dark:text-[#BFC0C0]/50">
          Built with care for the free-flight community.
        </p>
      </div>
    </div>
  )
}
